<template>
  <div class="program-block">
    <div class="img">
      <el-image v-if="type==0||type==20" :src=" data.imgPath||''" fit="cover">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <el-image v-if="type==1||type==21" :src="data.poster||''" fit="cover">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <span v-if="data.undertime">{{data.undertime | dateFormat}}</span>
    </div>
    <div class="desc">
      <h4>
        <slot name="state-slot"></slot>
        <span @click="goEditPage()">{{data.name}}</span>
        <slot name="title-slot"></slot></h4>
      <p class="row-dec">
        <span v-if="!(type ==0 && platform == 'UGC')">{{idName}}{{data.id}}</span>
        <span v-if="type == 1">总{{data.seriesAmount||0}}集 最新{{data.newestSeriesNo||0}}集</span>
        <span v-if="type ==0 && platform == 'CP'">视频时长: {{time|formatTime}}</span>
        <span v-if="type ==0">所属节目集: {{data.programSetName?data.programSetName:'未加入节目集'}}</span>
        <span v-if="(type == 20)||(type == 21) ">播放量:
          <span v-if="data.playCount">
            {{data.playCount | dealDataW}}
          </span>
          <span v-else>0</span>
        </span>
        <span v-if="type == 21">浏览量:
          <span v-if="data.browseCount">{{data.browseCount | dealDataW}}</span>
          <span v-else>统计中</span>
        </span>
      </p>
      <p class="row-dec">
        <span v-if="type == 21">总{{data.seriesAmount||0}}集 最新{{data.newestSeriesNo||0}}集</span>
          <span v-if="type ==20">视频时长: {{time|formatTime}}</span>
          <span>{{(type == 0)||(type == 20)?'上传时间：':'创建时间：'}}{{data.createTime | timeFormat}}</span>
          <span v-if="type ==0 && platform == 'UGC'">视频时长: {{time|formatTime}}</span>
          <el-tooltip v-if="type == 0 && platform == 'CP'" :content="videoPathShow" placement="top">
            <span><div class="div-cell">上传路径：{{videoPathShow}}</div></span>
          </el-tooltip>

          <slot name="row-slot"></slot>
      </p>
      <p class="row-dec" @click="openDoubleLineDialog(data,(['recommendplays','normalplays']))">
        <span v-if="type == 0"> 推荐播放量/次: <span>{{data.recommendplays}}</span></span>
        <span v-if="type == 0"> 普通播放量/次: <span>{{data.normalplays}}</span></span>
        <span v-if="type == 1"> 推荐播放数量: <span>{{data.recommendplays}}</span></span>
        <span v-if="type == 1"> 普通播放数量: <span>{{data.normalplays}}</span></span>
      </p>
      <!-- <slot name="audit-slot"></slot> -->
      <p class="info"><span v-if="data.des">{{data.des}}</span><slot name="info-slot"></slot></p >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: [String, Number],
      default: 0 // 0 节目  1 节目集  20 vod节目 21 vod节目集
    },
    project: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      idName: this.type == 0 ? '节目ID：' : this.type == 1 ? process.env.VUE_APP_NODE_ENV == 'UGC' ? '专辑ID：' : '节目集ID：' : 'ID：',
      videoPathShow: this.data.video && this.data.video.videoPath ? this.data.video.videoPath.substring(this.data.video.videoPath.lastIndexOf('/') - 11) : '',
      time: this.data.video ? this.data.video.lengthUnit == 0 ? this.data.video.length * 60 : this.data.video.length : '',
      platform: process.env.VUE_APP_NODE_ENV
      // videoTime: this.lengthUnit == 0 ? this.videoLength * 60 : this.videoLength
    }
  },
  filters: {
    formatTime (t) {
      if (!t) {
        return ''
      }
      const NowtimeValue = t
      let nowH = parseInt(NowtimeValue / 3600)
      let nowM = parseInt(NowtimeValue % 3600 / 60)
      let nowS = parseInt(NowtimeValue % 60)
      nowH < 10 ? nowH = '0' + nowH : nowH = nowH + ''
      nowM < 10 ? nowM = '0' + nowM : nowM = nowM + ''
      nowS < 10 ? nowS = '0' + nowS : nowS = nowS + ''
      return nowH + ':' + nowM + ':' + nowS
    }
  },
  methods: {
    goEditPage () {
      this.$emit('goEditPage', this.data.id)
    },
    openDoubleLineDialog (row, statisticsFields) {
      if (this.type == 0) {
        this.$parent.$parent.$parent.$parent.$refs.DoubleLineDialog.open()
        this.$parent.$parent.$parent.$parent.dialogData = {
          objData: row,
          limit: 'Y',
          statisticsFields: statisticsFields
        }
      } else if (this.type == 1) {
        this.$parent.$parent.$parent.$parent.$refs.DoubleLineDialog.open()
        this.$parent.$parent.$parent.$parent.dialogData = {
          objData: row,
          statisticsFields: statisticsFields
        }
      }
    }
  }
}
</script>

<style lang="less">
  .program-block {
    display: flex;
    .img {
      display: inline-block;
      padding-right: 10px;
      vertical-align: top;
      width: 170px;
      min-width: 170px;
      text-align: center;
      .el-image {
        width: 100%;
        height: 116px;
        font-size: 120px;
        color: #ccc;
        text-align: center;
      }
    }
    .desc {
      flex: 1;
      display: inline-block;
      vertical-align: top;
      h4 {
        margin: 13px 0 5px;
        font-size: 16px;
        line-height: 30px;
      }
      > p {
        margin: 0;
        line-height: 24px;
      }
      .row-dec-content {
        display: table;
      }
      .row-dec {
        display: table-row;
        >span{
          display: table-cell;
          padding-right: 30px;
          white-space: nowrap;
          cursor: default;
          .div-cell {
            max-width: 280px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      .info {
        width: 600px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    #videoPathArea {
      opacity: 0;
      width: 0px;
    }
  }
</style>
